import * as React from 'react'

import { useRouteCompanyId } from '@/modules/shared/hooks/useRouteCompanyId'
import { useTaskSync } from '@/modules/shared/hooks/useTaskSync'
import { useCompanySelectionStore } from '@/modules/shared/stores/companySelectionStore'


export const TaskSyncHost: React.FC = () => {
  const routeCompanyId = useRouteCompanyId()
  const selectedCompanyId = useCompanySelectionStore((s) => s.selectedCompany?.id)
  useTaskSync(routeCompanyId || selectedCompanyId || null)
  return null
}
